















import { tap } from "rxjs/operators";
import Component from "vue-class-component";
import { css } from "emotion";
import { DisposeBag } from "../../helpers";
import { LifeRenderProps } from "./LifeRenderProps";
import { CellStates, Life } from "../../types";
import { CELL_SIZE } from "../../constants";

@Component
export default class Controls extends LifeRenderProps {
  public readonly cellHeight = `${CELL_SIZE - 1}px`;

  public readonly cellWidth = `${CELL_SIZE}px`;

  public readonly cellCssClassName = css`
    height: ${CELL_SIZE - 1}px;
    width: ${CELL_SIZE}px;
    padding: 0;
    border: 1px solid #3e3e3e;
  `;

  public readonly aliveCell = CellStates.Alive;

  public life: Life = [[]];

  private readonly disposeBag = new DisposeBag();

  public mounted() {
    this.disposeBag.subscribe(
      this.game.life$.pipe(
        tap(life => {
          this.life = life;
        }),
      ),
    );
  }

  public setSpeedLevel({ x, y }: Readonly<{ x: number; y: number }>) {
    this.game.pause();
    this.game.toggleCell({ x, y });
  }
}
